<p-dialog [style]="{width: '70%'}" [breakpoints]="{ '1024px': '90%' }" [(visible)]="display" appendTo="body" (onHide)="hideDialog($event)" [modal]="true" [resizable]="false" [draggable]="false">
    <p-header style="color: royalblue">{{ 'ReceiptForm.Button.UploadAttachment' | translate }}</p-header>
    <ng-container *ngFor="let item of doFileOptionsList ; let i = index">
        <h3>
            {{item.title + " " + item.doNo}}
        </h3>
        <div class="container">
            <div class="grid">
                <div class="p-fluid col-12 md:col-6 lg:col-4 mb-3">
                    <label>{{ 'ReceiptFormUpload.DocumentType' | translate }}</label>
                    <p-dropdown appendTo="body" [options]="item.documentOptions" [(ngModel)]="item.selectedDocument" optionLabel="text" optionValue="value">
                        <ng-template let-doc pTemplate="item">
                            <div>
                                <i *ngIf="doc.priority == 1" class="fas fa-exclamation"></i>
                                <div>{{doc.text}}</div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
                <div class="field col-8">
                    <label>{{ 'ReceiptFormUpload.File' | translate }}</label>
                    <p-fileUpload
                    #fileUpload
                    [customUpload]="true"
                    (uploadHandler)="fileUploader($event, item, i)"
                    chooseLabel="{{ 'ReceiptFormUpload.Select' | translate }}"
                    uploadLabel="{{ 'ReceiptFormUpload.Upload' | translate }}"
                    cancelLabel="{{ 'ReceiptFormUpload.Cancel' | translate }}">
                    </p-fileUpload>
                </div>
            </div>
        </div>
        <div class="mt-2">
            <p-table [value]="item.docs" class="datatable" [resizableColumns]="true" [reorderableColumns]="true" [rowHover]="true" [loading]="item.isLoading" columnResizeMode="expand" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]" [autoLayout]="true" sortMode="multiple">
                <ng-template pTemplate="header">
                    <tr>
                        <th pResizableColumn pReorderableColumn>{{ 'ReceiptFormUpload.FileType' | translate }}</th>
                        <th pResizableColumn pReorderableColumn>{{ 'ReceiptFormUpload.Version' | translate }}</th>
                        <th pResizableColumn pReorderableColumn>{{ 'ReceiptFormUpload.UploadBy' | translate }}</th>
                        <th pResizableColumn pReorderableColumn>{{ 'ReceiptFormUpload.LastUpdateTime' | translate }}</th>
                        <th pResizableColumn pReorderableColumn>{{ 'ReceiptFormUpload.Download' | translate }}</th>
                        <th pResizableColumn pReorderableColumn>{{ 'ReceiptFormUpload.Delete' | translate }}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData>
                    <tr>
                        <td>{{rowData.docType}}</td>
                        <td>{{rowData.version}}</td>
                        <td>{{rowData.updateUser}}</td>
                        <td>{{rowData.updateDt | date:'yyyy/MM/dd HH:mm:ss'}}</td>
                        <td>
                            <i class="pi pi-cloud-download" (click)="downloadChange($event, rowData)"></i>
                        </td>
                        <td>
                            <i class="pi pi-trash" *ngIf="userProfile.userName == rowData.updateUser" (click)="deleteFileBtn($event, rowData)"></i>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="6" style="text-align: center;">
                            {{ 'Common.Table.NoData' | translate }}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </ng-container>
</p-dialog>
